import api from 'api/api'
import { toast } from 'react-toastify'

export const SAVE_PRODUCT_DESCRIPTION = '[PRODUCT FILES] SAVE PRODUCT DESCRIPTION'

export function saveProductDescriptionAction(data) {
  const request = api.post('/product-file/save-description', data)
  return (dispatch) => {
    dispatch({ type: SAVE_PRODUCT_DESCRIPTION, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PRODUCT_DESCRIPTION, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_PRODUCT_DESCRIPTION, error)
    }).finally(() => {
      dispatch({ type: SAVE_PRODUCT_DESCRIPTION, payload: { saving: false, saved: false } })
    })
  }
}